import { render, staticRenderFns } from "./cv-content-switcher.vue?vue&type=template&id=7a80f08f&"
import script from "./cv-content-switcher.vue?vue&type=script&lang=js&"
export * from "./cv-content-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports